import axios from 'axios'
import type {MutexResponse} from "@/types/mutex.ts";

const BASE_PATH = '/mutex'

const getMutexApiCall = async (
  abortController?: AbortController,
): Promise<MutexResponse> => {
  const { data } = await axios.get(`${BASE_PATH}`, { signal: abortController?.signal, params: {per_page: 500} })

  return data.data
}

export { getMutexApiCall }
